import translation from './translation.reducer';
var translationReducers = translation;
export default translationReducers;



//////////////////
// WEBPACK FOOTER
// ./src/translation/store/reducers/index.ts
// module id = 1490
// module chunks = 81